import { render, staticRenderFns } from "./exhibition-scan-photo.vue?vue&type=template&id=3af9eb5a&scoped=true&"
import script from "./exhibition-scan-photo.vue?vue&type=script&lang=js&"
export * from "./exhibition-scan-photo.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-scan-photo.vue?vue&type=style&index=0&id=3af9eb5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af9eb5a",
  null
  
)

export default component.exports